import React from "react";
import { Row, Container, Col } from "reactstrap";
import { FaLinkedinIn } from "react-icons/fa";

function DemoFooter() {
  return (
    <footer className="footer" style={{ background: "#2d2e41" }}>
      <Container fluid>
        <Row>
          <Col lg={1} xs={0} />
          <Col lg={4} style={{ paddingTop: "3rem" }}>
            <p className="text-400 text-white">Organised By</p>
            <a href="/">
              <img
                src={require("assets/images/logo/white.png")}
                alt="vibe"
                style={{ maxWidth: "150px" }}
              />
            </a>
          </Col>
          <Col lg={3} className={"text-left"} style={{ padding: "3rem" }}>
            <p>
              <a href="/" style={{ color: "#ffffff" }}>
                Home
              </a>
            </p>
            <p>
              <a href="/#about" style={{ color: "#ffffff" }}>
                About
              </a>
            </p>
            <p>
              <a href="/agenda" style={{ color: "#ffffff" }}>
                Agenda
              </a>
            </p>

            <p>
              <a href="https://saifee-events.com/privacy-policy" style={{ color: "#ffffff" }}>
                Privacy-Policy Saifee-Events
              </a>
            </p>
          </Col>
          <Col lg={4} style={{ padding: "3rem" }}>
            <p className="text-400 text-white">Connect With Us</p>

            {social.map((s) => (
              <a
                key={s.name}
                className={` text-900 px-2`}
                style={{
                  color: "#fff",
                  fontSize: "30px",
                }}
                href={s.link}
              >
                <FaLinkedinIn />
              </a>
            ))}
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} className={"text-center text-white pt-10"}>
            <p>Copyright © Saifee-Events {new Date().getFullYear()}. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default DemoFooter;

const social = [
  // {
  //   name: "facebook",
  //   link: "",
  // },
  // { name: "twitter", link: "" },
  {
    name: "linkedin",
    link: "https://www.linkedin.com/company/saifee/?viewAsMember=true",
  },
  // {
  //   name: "instagram",
  //   link: "",
  // },
];
